export default class MessageYoutubeModal {
  constructor(options = {}) {
    this.modalSelector = options.modalSelector || '.js-message-youtube-modal';
    this.triggerSelector = options.triggerSelector || '.js-message-youtube-trigger';
    this.iframeSelector = options.iframeSelector || '.js-message-youtube-iframe';
    this.innerSelector = options.innerSelector || '.p-message-youtube-modal__inner';
    this.closeSelector = options.closeSelector || '.js-message-youtube-close';
    this.openClass = options.openClass || 'is-message-youtube-modal-open';

    this.modal = document.querySelector(this.modalSelector);
    this.triggers = document.querySelectorAll(this.triggerSelector);

    if (!this.modal || !this.triggers.length) {
      return;
    }

    this.iframe = this.modal.querySelector(this.iframeSelector);
    this.inner = this.modal.querySelector(this.innerSelector);
    this.closeButton = this.modal.querySelector(this.closeSelector);

    if (!this.iframe || !this.inner || !this.closeButton) {
      return;
    }

    this.lastTrigger = null;
    this.init();
  }

  init() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(this.triggerSelector);

      if (trigger) {
        this.open(event, trigger);
      }
    });

    this.closeButton.addEventListener('click', () => this.close());

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal || event.target === this.inner) {
        this.close();
      }
    });

    this.modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });

    this.modal.addEventListener('close', () => this.cleanup());
  }

  open(event, trigger) {
    const youtubeId = trigger.dataset.youtubeId;

    if (!this.isValidYoutubeId(youtubeId) || typeof this.modal.showModal !== 'function') {
      return;
    }

    if (this.modal.open) {
      event.preventDefault();
      return;
    }

    this.modal.showModal();
    event.preventDefault();
    this.lastTrigger = trigger;
    this.iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0`;
    document.documentElement.classList.add(this.openClass);
    this.closeButton.focus({ preventScroll: true });
  }

  close() {
    if (!this.modal.open) return;
    this.modal.close();
  }

  cleanup() {
    this.iframe.removeAttribute('src');
    document.documentElement.classList.remove(this.openClass);

    if (this.lastTrigger?.isConnected) {
      this.lastTrigger.focus();
    }

    this.lastTrigger = null;
  }

  isValidYoutubeId(youtubeId) {
    return typeof youtubeId === 'string' && /^[A-Za-z0-9_-]{11}$/.test(youtubeId);
  }
}
